export const About = () => {

    return <div>About Page</div>
  }